import React from "react"
import {styled} from "@mui/material/styles"
import Typography from "@mui/material/Typography"
import {FALLBACK_FONT_FAMILY, breakpoints} from "@next/ux-fabric"
import {Button as MUIButton} from "@mui/material"
import {PropsOf} from "@emotion/react"

export const CloseIcon = styled("img")`
    display: flex;
    position: fixed;
    top: 0;
    left: 0;
    cursor: pointer;
    height: 2.75rem;
    width: 2.75rem;
`

const StyledClearButton = styled(MUIButton)`
    && {
        color: ${({theme}) => theme.uxfabric.components.link.primary.enabled.textColor};
        background: none;
        font-family: ${({theme}) => `${theme.uxfabric.global.body3.fontFamily}, ${FALLBACK_FONT_FAMILY}`} !important;
        font-size: 0.875rem;
        font-weight: ${({theme}) => theme.uxfabric.global.body3.fontWeight};
        line-height: 1.43;
        padding: 0;
        justify-content: flex-end;
        border: 0;
        text-transform: none;

        &:hover,
        &:active {
            background: inherit;
            border: 0;
        }

        &:focus {
            border: 0;
            border-radius: 0;
        }
    }
`

export const ClearButton = (props: PropsOf<typeof StyledClearButton>) => {
    return <StyledClearButton disableRipple {...props} />
}

export const Title = styled(Typography)`
    && {
        letter-spacing: ${({theme}) => theme.uxfabric.global.body1.letterSpacing};
        @media (min-width: ${breakpoints.values.md}px) {
            letter-spacing: normal;
            font-size: 0.875rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
`

export const HeaderContainer = styled("div")`
    align-items: center;
    background: ${({theme}) => theme.uxfabric.components.card.cardHeader.default.backgroundColor};
    border-bottom: 0.0625rem solid ${({theme}) => theme.uxfabric.components.card.cardHeader.default.borderColor};
    border-top: 0.0625rem solid ${({theme}) => theme.uxfabric.components.card.cardHeader.default.borderColor};
    display: flex;
    justify-content: space-between;
    padding: calc(0.75rem - 1px) 1.025rem calc(0.812rem - 1px) 1rem;
    color: ${({theme}) => theme.uxfabric.text.primary};

    @media (min-width: ${breakpoints.values.md}px) {
        background: ${({theme}) => theme.uxfabric.components.card.cardHeader.default.backgroundColor};
        padding: 0.5rem 0.625rem;
        border-top: 0;
        border-top-left-radius: inherit;
        border-top-right-radius: inherit;
    }
`

export const Wrapper = styled("div")`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    flex: 0 0 auto;
    justify-content: flex-start;
    margin: 0;
    padding: 0.25rem 1rem;
    color: ${({theme}) => theme.uxfabric.text.primary};

    @media (min-width: ${breakpoints.values.md}px) {
        padding: 0.125rem 0.625rem;
    }

    ul {
        margin: 0;
        padding: 0;

        @media (min-width: ${breakpoints.values.sm}px) and (max-width: ${breakpoints.values.md - 1}px) {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;

            li {
                flex-basis: calc(100% / 2);
                padding-right: 1rem;
            }
        }
    }
`

export const Container = styled("div")`
    background: white;

    @media (min-width: ${breakpoints.values.md}px) {
        border: 0.0625rem solid ${({theme}) => theme.uxfabric.components.menu.searchMenu.default.borderColor};
        width: 100%;

        border-radius: ${({theme}) => theme.uxfabric.shape.global.menu.default.borderRadius};
        margin-top: 4px;
        box-shadow: ${({theme}) => theme.uxfabric.elevation.menu};
    }
`

export const SeeAllLinkContainer = styled("div")`
    border-top: 0.0625rem solid ${({theme}) => theme.uxfabric.components.menu.searchMenu.default.borderColor};
    margin-top: 1rem;
    padding-top: 1rem;

    a {
        font-family: ${({theme}) => theme.uxfabric.global.body3.fontFamily}, ${FALLBACK_FONT_FAMILY} !important;
        font-weight: ${({theme}) => theme.uxfabric.global.body3.fontWeight};
        display: flex;
        justify-content: flex-end;
        color: ${({theme}) => theme.uxfabric.components.link.primary.enabled.textColor};
        text-decoration: underline;
        font-size: 0.875rem;

        @media (min-width: ${breakpoints.values.md}px) {
            padding-right: 1rem;
        }
    }
`

export const HeaderText = styled(Typography)`
    font-family: ${({theme}) => `${theme.uxfabric.global.subtitle2.fontFamily}, ${FALLBACK_FONT_FAMILY}`} !important;
    text-transform: ${({theme}) => theme.uxfabric.global.subtitle2.textTransform};
`
